<template>
  <div id="login">
    <div id="tab-bar">
      <ul class="tab-bom">
        <li style="padding-left:57px" @click="routerFuc('/home')"><img src="https://img.deepbaytech.com/fn/logo.png" style="height: 34px;"></li>
      </ul>
    </div>
    <div class="container common" :style="{height:containerHeight}">
      <div class="container_content">
        <el-row class="text-bottom">
          <el-col class="left">
            <div>
              <p class="title">致力于人工智能与传统产业深度融合</p>
              <p class="small-title">科技创新，轻松助力</p>
            </div>
          </el-col>
          <el-col class="pwd_box">
            <div class="password">
              <p class="pwd">密码登录</p>
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item prop="mobile">
                  <el-input v-model="ruleForm.mobile" placeholder="手机号"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input type="password" v-model="ruleForm.password" placeholder="密码"></el-input>
                </el-form-item>
              </el-form>
              <a style="margin-top: 56px;" class="tab-programme-a" @click="submitForm">登录</a>
              <p class="forget" @click="routerFuc('/user/forget')">忘记密码？</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="bottom">
        © 2019 Deepbay 使用前必读 增值电信业务经营许可证：B1.B2-20100266 京ICP证030173号 隐私政策
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Login",
  data () {
    return {
      ruleForm: {
        mobile: '13211111111',
        password: '1',
      },
      rules: {
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ]
      },
      containerHeight: null
    }
  },
  created () {
    this.containerHeight = document.body.clientHeight - 64 + 'px'
  },
  methods: {
    routerFuc (path) {
      this.$router.push(path)
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          alert('登录成功')
          this.$store.commit('setMobile', this.ruleForm.mobile)
          const backTo = this.$route.query.backto || '/'
          this.$router.push(backTo)
        } else {
          alert('请输入必填项')
          return false
        }
      })
    }
  },
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.common {
  min-width: 1180px;
}
#tab-bar {
  height: 64px;
}
.tab-bom {
  width: 100%;
  height: 64px;
  padding: 0;
  display: flex;
  justify-content: start;
  align-items: center;
}
.tab-bom > li {
  list-style: none;
  cursor: pointer;
}
.container {
  width: 100%;
  height: 80%;
  align-items: center;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-between;
  background: #f6f8fb;
  padding: 56px 0 63px 0;
  cursor: pointer;
}
.container:before {
  content: '';
  height: 0;
}
.container_content,
.pwd_box,
.left {
  display: flex;
  justify-content: center;
}
.container_content {
  flex: 1;
}
.text-bottom {
  height: 428px;
}
.title {
  color: #333333;
  font-size: 24px;
}
.small-title {
  margin-top: 20px;
  color: #333333;
  font-size: 16px;
}
.password {
  width: 400px;
  height: 428px;
  background: #ffffff;
  padding: 60px 40px;
}
.pwd {
  color: #333333;
  font-size: 28px;
  text-align: center;
  margin-bottom: 40px;
}
::v-deep .el-input__inner {
  border-radius: 0%;
}
.tab-programme-a {
  width: 100%;
}
.forget {
  color: #999999;
  font-size: 12px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.forget:hover {
  color: #77ba00;
}
.bottom {
  text-align: center;
  color: #666666;
  font-size: 12px;
  width: 100%;
  margin-top: 140px;
}
</style>
